module.exports = __webpack_public_path__ + "static/media/saas-advantage-icon-1.ce8d622c.png";